export default "__VITE_ASSET__Dyk6cRum__"